import React, {useState} from 'react';
import {Button, Input, message, Space} from 'antd';
import {Auth} from "aws-amplify";

const ResetPassword = (props) => {
    const [currentPassword, setCurrentPassword] = useState('');
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');

    const handleOk = () => {

        if (currentPassword === '') {
            message.warning("Please enter current password!");
        } else if (password === '' || confirmPassword === '' || password !== confirmPassword) {
            message.warning("Passwords don't match!");
        } else {
            Auth.currentAuthenticatedUser()
                .then(user => {
                    return Auth.changePassword(user, currentPassword, password);
                })
                .then(data => {
                    message.success("Password changed successfully.");
                    setCurrentPassword('');
                    setPassword('');
                    setConfirmPassword('');
                })
                .catch(err => message.error(err.message));
        }
    };

    return (
        <>

            <div style={{marginTop: 20}}>
                <Space direction="vertical" style={{width: '40%'}}>
                    <Input.Password placeholder="Current Password" value={currentPassword}
                                    onChange={(e) => setCurrentPassword(e.target.value)}/>
                    <Input.Password placeholder="New Password" value={password}
                                    onChange={(e) => setPassword(e.target.value)}/>
                    <Input.Password placeholder="Confirm New Password" value={confirmPassword}
                                    onChange={(e) => setConfirmPassword(e.target.value)}/>
                    <Button type="primary" onClick={handleOk}>Save</Button>
                </Space>


            </div>

        </>
    );
};

export default ResetPassword;